export default [{  // 商品统计
	path: 'statistic_product',
	name: 'm_analysis_product',
	component: () => import('@/pages/analysis/statistic_product')
}, {  // 交易统计
	path: 'statistic_trans',
	name: 'm_analysis_trans',
	component: () => import('@/pages/analysis/statistic_trans')
}, {  // 会员统计
		path: 'statistic_user_list',
		name: 'm_statistic_platform_user',
		component: () => import('@/pages/analysis/statistic_platform_user')
}];